import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Context from '../../context/Context'
import { InvoiceTypes } from '../../helpers/Constants'

const findVat = (invoiceLines) => {
  const invoiceLine = invoiceLines.find((row) => {
    return (parseInt(row.item_id) === -2)
  })

  return (invoiceLine !== undefined) ? invoiceLine.amount : null
}

const GroupInvoiceRow = ({ index, invoiceLine }) => {
  return (
    <tr key={index}>
      <td className="table-group-invoice-product">
        <span className="paragraph-bold-12">{invoiceLine.product}</span>
      </td>
      <td colSpan="2" className="table-group-invoice-amount text-end">
        <span className="paragraph-regular-12">{invoiceLine.amount} kr</span>
      </td>
    </tr>
  )
}

const Row = ({ index, invoiceLine }) => {
  if (parseInt(invoiceLine.font_format) === 1 &&
    (parseInt(invoiceLine.vat_item) === 1 || parseInt(invoiceLine.input_vat_item) === 1) &&
    invoiceLine.price_unit !== 'kr'
  ) {
    return (
      <tr key={index}>
        <td className="table-product-col">
          <span className="paragraph-bold-12">{invoiceLine.product}</span>
        </td>
        <td className="table-price-col">
          <span className="paragraph-regular-12">{invoiceLine.price} {invoiceLine.price_unit}</span>
        </td>
        <td className="text-end table-amount-col">
          <span className="paragraph-regular-12">{invoiceLine.amount} kr</span>
        </td>
      </tr>
    )
  } else {
    return (
      <tr key={index}>
        <td className="table-product-col">
          <span className="paragraph-bold-12">{invoiceLine.product}</span>
        </td>
        <td colSpan="2" className="text-end table-amount-col">
          <span className="paragraph-regular-12">{invoiceLine.amount} kr</span>
        </td>
      </tr>
    )
  }
}

const InvoiceDetails = ({ invoiceLines }) => {
  const context = useContext(Context)
  const vatSum = findVat(invoiceLines)

  return (
    <div className="row mt-5 col-10 offset-1 col-sm-8 offset-sm-2">
      <table className="table table-sm">
        <tbody>
          {invoiceLines.map((invoiceLine, index) => (
            (parseInt(invoiceLine.item_id) >= 0)
              ? (parseInt(context.invoice.invoice_type_id) === InvoiceTypes.GROUP)
                ? <GroupInvoiceRow key={index}
                  index={index}
                  invoiceLine={invoiceLine} />
                : <Row key={index}
                  index={index}
                  invoice={context.invoice}
                  invoiceLine={invoiceLine} />
              : null
          ))}
        </tbody>
        <tfoot>
          <tr className="summary-row-background">
            <td>
              <span className="paragraph-bold-12">Summa</span>
            </td>
            <td colSpan="2" className="text-end">
              {(vatSum !== null)
                ? <span className="paragraph-bold-12">{context.invoice.total_amount} kr*</span>
                : <span className="paragraph-bold-12">{context.invoice.total_amount} kr</span>
              }
            </td>
          </tr>
          {(vatSum !== null)
            ? <tr>
              <td colSpan="3" className='text-end' style={{ border: 'none' }}>
                <span className="paragraph-regular-12 fw-light"><i>*varav moms {vatSum} kr</i></span>
              </td>
            </tr>
            : null
          }
        </tfoot>
      </table>
    </div>
  )
}

InvoiceDetails.propTypes = {
  invoiceLines: PropTypes.array.isRequired
}

Row.propTypes = {
  index: PropTypes.any.isRequired,
  invoiceLine: PropTypes.object.isRequired
}

GroupInvoiceRow.propTypes = {
  index: PropTypes.any.isRequired,
  invoiceLine: PropTypes.object.isRequired
}

export default InvoiceDetails
